import { components } from 'react-select'

import type { ComponentType, ReactElement, ReactNode } from 'react'
import type { ControlProps, GroupBase, MenuProps, OptionProps, ValueContainerProps } from 'react-select'
import type { IOptionWithIcon } from '~/types/option'

export const Menu = (props: MenuProps, classes: string): ReactElement => {
  return (
    <components.Menu {...props} className={classes}>
      {props.children}
    </components.Menu>
  )
}

export const Option = (
  props: OptionProps,
  CustomOption?: ComponentType<OptionProps<unknown, boolean, GroupBase<unknown>>>
): ReactElement => {
  /** Local state */

  const { className, data, label } = props

  const { icon } = data as IOptionWithIcon

  /** Render */

  return (
    <components.Option {...props} className={className}>
      {icon ? <div className="option-icon-wrapper">{icon}</div> : null}
      {CustomOption ? <CustomOption {...props} /> : <div className="option-label">{label}</div>}
    </components.Option>
  )
}

export const Control = (props: ControlProps): ReactElement => {
  const { children, getValue, hasValue, selectProps } = props

  const castedGetValue = getValue() as IOptionWithIcon[]

  const optionIcon = castedGetValue.length > 0 && castedGetValue[0].icon

  const { defaultIcon } = selectProps

  return (
    <components.Control {...props}>
      {hasValue && defaultIcon ? (
        <>
          {getValue().length < 2 && optionIcon ? (
            <div className="icon-wrapper">{optionIcon}</div>
          ) : (
            <div className="icon-wrapper">{defaultIcon}</div>
          )}
        </>
      ) : null}
      {children}
    </components.Control>
  )
}

export const ValueContainer = (props: ValueContainerProps): ReactElement => {
  const { children, getValue, hasValue, selectProps } = props

  const [, input] = children as ReactNode[]

  const valuesCount = getValue().length

  const { isFocused, menuIsOpen, optionType } = selectProps

  return (
    <components.ValueContainer {...props}>
      {!menuIsOpen && !isFocused && hasValue && valuesCount > 1 ? (
        <>
          <span>
            {valuesCount} {optionType ?? 'Options'}
          </span>
          {input}
        </>
      ) : (
        children
      )}
    </components.ValueContainer>
  )
}
